module.exports = __webpack_public_path__ + "img/logo.4b22b8bc.png";